import type { PhotoAnnotation } from '../types/photo.types';

export interface PinAudioJob {
  photoIndex: number;
  pinId: string;
  blob: Blob;
}

export interface PinAudioResult {
  photoIndex: number;
  pinId: string;
  url: string;
}

export function collectPinAudioBlobs(anns: PhotoAnnotation[]): PinAudioJob[] {
  const jobs: PinAudioJob[] = [];
  anns.forEach((ann, photoIndex) => {
    ann.pins.forEach(pin => {
      if (pin.audioBlob) jobs.push({ photoIndex, pinId: pin.id, blob: pin.audioBlob });
    });
  });
  return jobs;
}

export function substitutePinAudioUrls(
  anns: PhotoAnnotation[],
  results: PinAudioResult[],
): PhotoAnnotation[] {
  const byKey = new Map(results.map(r => [`${r.photoIndex}:${r.pinId}`, r.url]));
  return anns.map((ann, photoIndex) => ({
    ...ann,
    pins: ann.pins.map(pin => {
      const url = byKey.get(`${photoIndex}:${pin.id}`);
      if (url) {
        const { audioBlob, ...rest } = pin;
        return { ...rest, audioUrl: url };
      }
      // Strip any stray audioBlob even without a matching URL (defensive).
      const { audioBlob, ...rest } = pin;
      return rest;
    }),
  }));
}
